import type { IACLEmail } from "./types";

export type AssignmentMode = "round_robin" | "weighted";
export type WeeklyHours = 35 | 40 | 45;

export interface AssignmentConfiguration {
    mode: AssignmentMode;
    last_score: number;
}

export interface CoordinatorTimeOff {
    start: string;
    end: string;
    note?: string;
    created_by: string;
    created_at: unknown;
}

export interface AssignmentEvent {
    client_id: string;
    assigned_to: string;
    mode: AssignmentMode;
    weekly_hours: WeeklyHours;
    returning_client: boolean;
    fallback: boolean;
    skipped: { email: string; reason: "time_off" | "booking_not_ready" }[];
    created_at: unknown;
}

export function assignmentWeeklyHours(value: unknown): WeeklyHours {
    return value === 35 || value === 45 ? value : 40;
}

/** Coordinator identity is explicit; pausing allocation never removes the role. */
export function isActiveCareCoordinator(
    account?: Pick<IACLEmail, "acl" | "deleted">
): boolean {
    return (
        account?.acl?.care_coordinator === true &&
        !account.deleted &&
        !account.acl.blocked
    );
}

export function canAutoAssignToCoordinator(
    account?: Pick<IACLEmail, "acl" | "deleted">
): boolean {
    return (
        isActiveCareCoordinator(account) &&
        account?.acl?.can_be_auto_assigned === true
    );
}
